import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { SetSelectedCampaign } from '../../store/slice/campaign.slice';
import { useCreateNewSessionMutation } from '../../store/api/session.api';
import { getActiveBrand } from '../../store/selector/brand.selector';
import { AddSession, SetCurrentlyWorkingSession } from '../../store/slice/session.slice';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { getSessions } from '../../store/selector/session.selector';
import { getEmptySession } from '../../utils/session.utils';

interface IProps {
    selectingPlanId: string | null;
    setSelectingPlanId: React.Dispatch<React.SetStateAction<string | null>>;
}

const NewCampaignPlan = ({ selectingPlanId, setSelectingPlanId }: IProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const activeBrand = useAppSelector(getActiveBrand);
    const sessions = useAppSelector(getSessions);
    const [createNewSession] = useCreateNewSessionMutation();

    const handlePlanSelect = async () => {
        if (!activeBrand || selectingPlanId !== null) return;
        setSelectingPlanId('');
        dispatch(SetSelectedCampaign(null));
        let session = getEmptySession(sessions);
        if (!session) {
            const response = await createNewSession(activeBrand.id);
            if (response && 'data' in response) {
                session = response.data;
                dispatch(AddSession(session));
            }
        }
        if (session) {
            dispatch(SetCurrentlyWorkingSession(session));
            dispatch(SetSelectedCampaign(null));
            navigate(`/campaign?q=${session.sessionKey}`);
        }
        setSelectingPlanId(null);
    };

    return (
        <div
            className="tw-w-[328px] tw-flex tw-flex-col tw-gap-y-2 tw-items-center tw-justify-center tw-border tw-rounded-lg tw-cursor-pointer"
            onClick={handlePlanSelect}
        >
            {selectingPlanId === '' ? (
                <Spinner className="tw-text-purple-500" />
            ) : (
                <i className="ph-bold ph-plus lg tw-rounded-full tw-bg-purple-50 tw-text-purple-500 tw-p-3"></i>
            )}
            <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-text-lg tw-text-[#374151]">Create New Plan</div>
                <div className="tw-text-sm tw-text-[#6B7280] ">Start from scratch</div>
            </div>
        </div>
    );
};

export default NewCampaignPlan;
